import { Location } from '@app/shared/routes';

const SigninCallbackLocation = new Location({
  path: '/signin-callback'
});

export { SigninCallbackLocation };
